// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scatterPlot-container {
  position: relative;
}

.scatterPlot-circle {
  filter: grayscale(0);
}

.scatterPlot-circle:hover {
  cursor: pointer;
  stroke-width: 2px;
}

.dimmed {
  filter: grayscale(100%);
  opacity: 0.1;
  transition: all;
  transition-delay: 0.5s;
  transition-duration: 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ScatterPlot/ScatterPlot.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":[".scatterPlot-container {\n  position: relative;\n}\n\n.scatterPlot-circle {\n  filter: grayscale(0);\n}\n\n.scatterPlot-circle:hover {\n  cursor: pointer;\n  stroke-width: 2px;\n}\n\n.dimmed {\n  filter: grayscale(100%);\n  opacity: 0.1;\n  transition: all;\n  transition-delay: 0.5s;\n  transition-duration: 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
